<div *ngIf="loading" class="spinner-container d-flex justify-content-center align-items-center">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div *ngIf="!loading" [ngClass]="templateTheme">
    <section id="banner" *ngIf="slides.length" [style.backgroundImage]="'url(' +  encodeUrl(slides[0].src) +')'"
        class="d-flex">
        <div class="left_sidebar d-none d-sm-block">
            <div class="fairbridge_logo">
                <ng-template [ngIf]="!!logo">
                    <img class="img-responsive hotel" alt="LOGO" [src]="assets_base + encodeUrl(logo?.imagePath)">
                </ng-template>
            </div>

            <div>
                <ul>
                    <li (click)="scrollTo('hotel_details')">Hotel Details</li>
                    <li (click)="scrollTo('amenities_section')">Amenities</li>
                    <li (click)="scrollTo('choose_your_room')">Room Types</li>
                    <li (click)="scrollTo('gallery')">Gallery</li>
                    <li (click)="scrollTo('DirectionsBlock')">Map</li>
                    <li (click)="scrollTo('contact')">Contact Us</li>
                </ul>
            </div>

            <div class="top_address">
                <div>
                    {{property?.property?.street}}, {{property?.property?.city}}, <br> {{property?.property?.state}}
                    {{property?.property.postalCode}}
                </div>
                <div>
                    <a [href]="'tel:'+ property?.property?.phoneNumber">
                        {{property?.property?.phoneNumber}}
                    </a>
                </div>
                <div class="d-grid pt-4">
                    <button class="btn btn-light" type="button" (click)="bookNow()">Book Now</button>
                </div>
            </div>

        </div>

        <div class="right_side d-flex flex-column flex-md-row align-content-center">
            <div class="caption flex-fill">
                <div class="mobile-logo">
                    <img *ngIf="logo" class="hotel" alt="LOGO" [src]="assets_base + encodeUrl(logo?.imagePath)">
                </div>
                <h3>{{property?.property?.name}}<br> {{property?.property?.city}}</h3>

                <button class="btn btn-warning text-uppercase mt-4 px-4 py-2" type="button"
                    (click)="scrollTo('choose_your_room')">Explore
                    Rooms</button>
            </div>

            <div class="book_now_container d-flex flex-column align-content-center">
                <div class="d-flex flex-fill align-items-center">
                    <div class="book_now">
                        <div>
                            <div class="circle_blue">
                                <ng-template [ngIf]="!!logo">
                                    <img class="img-responsive" width="90" style="margin:auto"
                                        [src]="assets_base + encodeUrl(logo?.imagePath)">
                                </ng-template>
                            </div>
                            <div class="checkin_location">
                                <p>
                                    <span class="material-icons me-2">map</span>
                                    {{property?.property?.street}}, {{property?.property?.city}},
                                    {{property?.property?.state}} {{property?.property.postalCode}}
                                </p>
                                <a [href]="'tel:'+ property?.property?.phoneNumber">
                                    <span class="material-icons me-2">call</span>
                                    {{property?.property?.phoneNumber}}
                                </a>
                            </div>
                            <div class="input-block dates">
                                <input type="text" ngxDaterangepickerMd class="form-control"
                                    [(ngModel)]="selectedDateRange" [ngModelOptions]="{standalone: true}"
                                    [autoApply]="true" [opens]="'right'" [minDate]="minDate"
                                    placeholder="Check-in &nbsp; &nbsp; &mdash; &nbsp; &nbsp; Check-out" />
                            </div>
                            <div class="book_now_button">
                                <button class="btn btn-warning text-uppercase w-sm-80 mt-2 px-4" type="button"
                                    (click)="bookNow(bookingType.DATE)">Book Now</button>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="facilities align-self-end">
                    <ul class="" id="amenities_section">
                        <li *ngFor='let amenity of property?.amenities'>
                            <div *ngIf="!amenity?.matIcon" style="text-align: center;">
                                <img [src]="'https://gw.faircloudpms.com/booking' + amenity?.logo" alt="">
                            </div>
                            <div class="amenity-icon-mat" *ngIf="amenity?.matIcon">
                                <span class="material-icons">{{amenity?.matIcon}}</span>
                            </div>
                            {{amenity?.name}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <section class="hotel_details">
        <div class="container image-container text-center">
            <img [src]="assets_base + encodeUrl(front_desk_image?.imagePath)" />
        </div>
        <div class="container text-container">
            <div class="details_box text-center">
                <h3>{{property?.property?.name}}</h3>
                <div class="property-description" [innerHTML]="property?.property?.description">
                </div>
            </div>
            <div class="footer text-center">
                <div class="handicap-instructions">
                    <p>Checkin Time: {{formatTime(property?.property?.checkinTime)}}
                        Checkout Time: {{formatTime(property?.property?.checkoutTime)}}</p>
                </div>
                <div class="add-space-top">
                    <button class="btn btn-warning book-now-section-2 text-uppercase w-sm-80 mt-2 px-4" type="button"
                        (click)="bookNow()">Book Now</button>
                </div>
            </div>
        </div>
    </section>
    <section class="accessibility">
        <div>
            <h1 class="title mt-4">Accessibility</h1>
        </div>
        <div class="mb-4">
            <p *ngIf="property?.property?.handicapInstructions" [innerHTML]="property?.property?.handicapInstructions">
            </p>
            <a [href]="'tel:'+ property?.property?.phoneNumber">
                <button class="btn btn-warning text-uppercase add-space-top mt-2 px-4" type="button"
                    (click)="bookNow()">
                    <span class="material-icons me-2">call</span> Call Hotel</button>
            </a>
        </div>
    </section>

    <section class="choose_your_room" id="choose_your_room">
        <div>
            <h1 class="main_head">Choose Your Room</h1>
        </div>
        <div class="container-fluid container">
            <div class="row">
                <div class="rooms">
                    <ul>
                        <ng-template ngFor let-roomType [ngForOf]="roomTypes" let-i="index">
                            <li class="room-list-item">
                                <div class="d-flex flex-column flex-md-row justify-content-center">
                                    <div class="image_container w-50 flex-grow-1">
                                        <img [src]="assets_base + encodeUrl(roomType?.roomTypeImages[0]?.imagePath)" />
                                    </div>

                                    <div class="text-container flex-grow-0 w-50">

                                        <div class="room-description">
                                            <h3 class="room-type">{{roomType?.type}}</h3>
                                            <app-read-more [content]="roomType?.description" [limit]="350">
                                            </app-read-more>
                                            <div class="text-end book-now-btn">
                                                <button class="btn btn-warning book-room-now text-uppercase mt-3 px-4"
                                                    type="button"
                                                    (click)="bookNow(bookingType.LOCATION, roomType?.type)">Book
                                                    Now</button>
                                            </div>
                                        </div>

                                        <nav class="nav mt-2">
                                            <div class="nav-link">Plans:</div>
                                            <div class="nav-link">Best Rate</div>
                                            <div class="nav-link">AAA/AARP</div>
                                            <div class="nav-link">Rack Rate</div>
                                        </nav>
                                    </div>
                                </div>
                            </li>
                        </ng-template>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <section id="gallery">
        <h3 class="main_head" style="color: #fff;">Picture Gallery </h3>
        <div class="container-fluid">
            <swiper-container slides-per-view="3" space-between="30" navigation="true" autoplay-delay="2500" loop="true"
                scrollbar="true">
                <swiper-slide *ngFor="let slide of slides"><img [src]="slide.src" /></swiper-slide>
            </swiper-container>
        </div>
    </section>

    <div *ngIf="property?.property?.latitude && property?.property?.longitude" id="DirectionsBlock">
        <google-map [options]="googleMapOptions"
            [center]="{lat: property?.property?.latitude, lng: property?.property?.longitude}" [zoom]="9" width="100%">
            <map-marker [position]="{lat: property?.property?.latitude, lng: property?.property?.longitude}">
            </map-marker>
        </google-map>

        <div class="address_block">
            <h3>{{property?.property?.name}}</h3>
            <p>
                <u>
                    <a [href]="'http://maps.google.com/maps?q=' + property?.property?.latitude + ',' + property?.property?.longitude"
                        target="_blank">
                        {{property?.property?.street}}, {{property?.property?.city}}
                        <br>
                        {{property?.property?.state}}, {{property?.property.postalCode}}
                    </a>
                    <br>
                    <a [href]="'tel:' + property?.property?.phoneNumber">
                        <span class="material-icons me-2">call</span>

                        {{property?.property?.phoneNumber}}
                    </a>
                </u>
            </p>
            <button class="btn btn-warning text-uppercase mt-4 px-4" type="button" (click)="bookNow()">Book Now</button>
        </div>
    </div>

    <app-contact-form [propertyId]="property?.property?.id"></app-contact-form>

    <div class="mb-4">
        <div class="contact_circle">
            <div class="contact_circle_img mb-2">
                <img *ngIf="logo?.imagePath" class="mb-2" [src]="assets_base + encodeUrl(logo?.imagePath)">
            </div>
            <p>{{property?.property?.name}}</p>
        </div>
    </div>

    <p class="text-center ">
        &#169; Copyright {{year}}, {{property?.property?.name}}. All rights reserved
    </p>
</div>